export const generateTimestampQuery = () => `?ts=${new Date()
  .getTime()}`;
